import { Injectable, inject } from '@angular/core';

import type { Observable } from 'rxjs';

import { HttpApiService } from '@core/http-legacy';
import type { InvoiceDownloadURL, InvoiceResourceType } from '@core/invoices-types';

@Injectable({ providedIn: 'root' })
export class InvoiceDownloadUrlService {
  protected readonly httpApi = inject(HttpApiService);

  public get(invoiceId: string, resourceType: InvoiceResourceType): Observable<InvoiceDownloadURL> {
    return this.httpApi.get<InvoiceDownloadURL>(`/invoices/${invoiceId}/pdf`, {
      resource_type: resourceType,
    });
  }
}
